import {
  Modal,
  ModalActionButton,
  ModalActions,
  ModalCloseIconButton,
  ModalContent,
  ModalTitle,
  Stack,
  Typography,
} from '@ace-clublabs/shared-component-library';
import { useContext } from 'react';
import { MembershipAppStateContext } from '../components/MembershipAppState/MembershipAppState';

export interface ConfirmZipCodeModalContentProps {
  isOpen: boolean;
  closeModal: () => void;
  confirm: () => void;
}

export const ConfirmZipCodeModal: (props: ConfirmZipCodeModalContentProps) => JSX.Element = ({
  isOpen,
  closeModal,
  confirm,
}) => {
  const { sessionData } = useContext(MembershipAppStateContext);
  return (
    <Modal
      open={isOpen}
      onClose={() => {
        closeModal();
      }}
      className="confirm-zip-code-modal"
    >
      <ModalTitle
        id={`confirmZipCodeModalTitle`}
        sx={{
          fontSize: '20px !important',
          marginRight: '24px !important',
          fontWeight: '500',
          marginBottom: '0 !important',
        }}
      >
        Keep ZIP code {sessionData.formData.residenceAddress.zipCode}?
        <ModalCloseIconButton
          aria-label="Close"
          onClick={() => {
            closeModal();
          }}
        />
      </ModalTitle>

      <ModalContent id="modal-content-remove">
        <Stack className="address-compare-container">
          <Stack className="address-compare-column qm-mask" data-di-mask="true">
            <Typography variant="b1Regular">The ZIP code entered is not covered by this AAA club.</Typography>
            <br />
            <Typography variant="b1Regular">
              Select Cancel to go back and enter a different ZIP code or Confirm to be redirected to the correct club.
            </Typography>
          </Stack>
        </Stack>
      </ModalContent>
      <ModalActions
        actionLayout={{
          sm: 'shared',
          md: 'shared',
          lg: 'shared',
          xl: 'shared',
        }}
      >
        <ModalActionButton
          variant="outlined"
          id="cancelNewZip"
          label="Cancel"
          onClick={() => {
            closeModal();
          }}
        />
        <ModalActionButton
          variant="contained"
          id="confirmNewZip"
          label="Confirm"
          onClick={() => {
            confirm();
          }}
        />
      </ModalActions>
    </Modal>
  );
};
